import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'

import {
    PropertiesController,
    usePropertiesController,
} from '../../SidePanel/RightPanel/PropertiesController.jsx'

import SelectUi from '../UI/SelectUi.jsx'

export default function PropertiesControllerUi({
    className,
    style,
    codeProp = 'uiCode',
    disabled,
    hidden,
    idProp = 'uiId',
    label,
    labelSuffix,
    nameProp = 'uiName',
    readOnly,
    required,
    ...props
}) {
    const [values, update] = useProperties()

    const {
        [codeProp]: uiCode,
        [idProp]: uiId,
        [nameProp]: uiName,
    } = values

    const handleChange = ui => {
        const {
            uiCode = '',
            uiId = '',
            uiName = '',
        } = ui ?? {}

        update({
            [codeProp]: uiCode,
            [idProp]: uiId,
            [nameProp]: uiName,
        })
    }

    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop: codeProp,
        readOnly,
        required,
    })

    return (
        <PropertiesController
            className={className}
            style={style}
            hidden={p.hidden}
            label={p.label}
            labelSuffix={labelSuffix}
            required={p.required}
        >
            <SelectUi
                disabled={p.disabled}
                readOnly={p.readOnly}
                value={{uiCode, uiId, uiName}}
                onChange={handleChange}
                {...props}
            />
        </PropertiesController>
    )
}
